<template>
    <div class="default-warpper">
      <h1>{{ videoList[index].title }}</h1>
      <div class="main">
        <video controls width="100%">
          <source :src="videoList[index].url" type="video/mp4" />
        </video>
        <center style="padding: 16px; font-size: 14px">不符谨防假冒</center>
      </div>
      <div class="footer">
        <a @click="$router.back(-1)">返回</a>
        <a @click="$router.back(-1)">证书鉴定中心</a>
      </div>
    </div>
  </template>
    
    <script>
  export default {
    data: () => {
      return {
        videoList: [],//[{ title: '防伪安全线', url: require('../../assets/video/视频4：防伪纤维.mp4') }, { title: '防伪纤维', url: require('../../assets/video/视频4：防伪纤维.mp4') }, { title: '特征2识别', url: require('../../assets/video/视频3：安全线.mp4') }, { title: '1、变色特征视频', url: require('../../assets/video/视频1：纹理变色.mp4') },],
        index: 0
      }
    },
    mounted: function () {
      this.index = parseInt(this.$route.query.flag)
    },
    methods: {
  
    }
  }
    </script>
    
    <style lang="scss" scoped>
  .default-warpper {
    padding: 10px;
    h1 {
      text-align: center;
      font-size: 24px;
      margin: 30px auto;
    }
    p {
      font-size: 18px;
      line-height: 36px;
    }
    .help-center {
      text-align: center;
      font-size: 18px;
      line-height: 36px;
      margin: 30px auto;
      color: #009be5;
    }
    .footer {
      position: fixed;
      bottom: 0;
      left: 0;
      height: 60px;
      font-size: 16px;
      display: flex;
      width: 100%;
      line-height: 60px;
      background: #fff;
      a {
        flex: 1;
        text-align: center;
        color: #009be5;
      }
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/example01/video.vue